export default __webpack_public_path__ + "static/media/Meditating-at-sunset.c8969dc5.jpg";